import { useApiQuery } from '@/api/main/query'
import { PaginatedCollection } from '@/api/types'
import { disputsAPI } from '@/features/orders/api/endpoints'
import { DisputListModel } from '@/features/orders/model/types'
import { useToast } from '@/shared/hooks'
import { useEffect, useState } from 'react'

type UseDisputsListProps = {
  skip: number
  take: number
  textFilter?: string
  status: number
}

type UseDisputsListOptions = {
  enabled?: boolean
}

export const useGetDisputsList = (
  { skip, take, textFilter, status }: UseDisputsListProps,
  options: UseDisputsListOptions = {}
) => {
  const { addToast } = useToast()
  const { enabled = true } = options
  const [isErrorHandled, setIsErrorHandled] = useState(false)

  const queryKey = ['disputs', skip, take, status]
  if (textFilter) queryKey.push(textFilter)

  const queryParams: Record<string, string | number | boolean | undefined> = {
    skip,
    take,
    status,
  }
  if (textFilter) {
    queryParams.textFilter = textFilter
  }

  const query = useApiQuery<PaginatedCollection<DisputListModel[]>>(
    queryKey,
    disputsAPI.list,
    queryParams,
    {
      enabled,
    }
  )

  useEffect(() => {
    if (query.error && !isErrorHandled) {
      addToast('Ошибка!', query.error.message, 'error')
      setIsErrorHandled(true)
    }
  }, [query.error, addToast, isErrorHandled])

  return query
}
